import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import useCheckPermission from '../../hooks/useCheckPermission';
import subscriptionService from './subscriptionService';
import SubscriptionForm from './SubscriptionForm';

const SubscriptionCreate = (props: any) => {
  const { onSave = null, navigateBack = true, handleCancel = null } = props;
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const [errors, setErrors] = useState<string[]>([]);
  const { canPlatform } = useCheckPermission();

  const onSubmit = (entity: any, setSubmitting: any) => {
    dispatch({ type: 'SHOW_SAVE' });
    subscriptionService
      .create({
        ...entity,
        startsAt: entity.startsAt || null,
        endsAt: entity.endsAt || null,
      })
      .then((response) => {
        if (response.hasError) {
          setErrors(response.errorMessages ?? []);
          enqueueSnackbar((response.errorMessages ?? []).join(','), {
            variant: 'error',
          });
        } else {
          enqueueSnackbar('Success!', { variant: 'success' });
          if (onSave) onSave(response.result);
          if (navigateBack) navigate(-1);
        }
      })
      .finally(() => {
        dispatch({ type: 'HIDE' });
        if (setSubmitting) setSubmitting(false);
      });
  };

  return (
    <SubscriptionForm
      entity={{
        name: '',
        tenantId: '',
        licenseId: null,
        paymentOccurrence: 'Monthly',
        status: 1,
        startsAt: '',
        endsAt: '',
      }}
      readonly={!canPlatform(['ManageSubscriptions'])}
      onSubmit={onSubmit}
      errors={errors}
      handleCancel={() =>
        handleCancel != null ? handleCancel() : navigate(-1)
      }
    />
  );
};

export default SubscriptionCreate;
